import React from "react";
import "./about.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import aboutimg from "../../Media/Hardsell_GW.webp";
import {faCheckDouble} from "@fortawesome/free-solid-svg-icons";

const About = () => {
  const handleConsultationClick = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6287876666122&text=Halo%20Anggi,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Grand%20Wisata%20(Promo)%20https://perumahan-grand-wisata.com//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  return (
    <div className="about">
      <div id="about" className="container-about">
        <h1>Grand Wisata A Home That Has Everything</h1>
        <div className="container-desk">
          <div className="desk">
            Grand Wisata adalah sebuah kawasan pemukiman yang terletak di Tambun
            Selatan, Bekasi, Jawa Barat. Dikembangkan oleh Sinarmas Land dengan
            konsep kota mandiri. Guna menarik pembeli Grand Wisata menawarkan
            promo yang menggiurkan seperti :
          </div>
        </div>
        <div id="promo" className="container-benefit">
          <div className="benefit-list">
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#00234B" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Siap Huni
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#00234B" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Free DP
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#00234B" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Free PPN
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#00234B" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Free Biaya KPR
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#00234B" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Free Furnished
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#00234B" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Disc Special KPR DP Cicil 2%*
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#00234B" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Disc Special Cash Bertahap 5%*
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#00234B" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Disc Special Cash Keras 10*
              </span>
            </div>
          </div>
          <div className="benefit-list">
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#00234B" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Disc Lucky Dip 10 Juta
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#00234B" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Full Smarthome System
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#00234B" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Free Smart Door Lock
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#00234B" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Free Canopy
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#00234B" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Free CCTV
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#00234B" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Free Solar Panel
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#00234B" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;Free Lift
              </span>
            </div>
            <div className="penawaranpoin">
              <FontAwesomeIcon icon={faCheckDouble} color="#00234B" />
              <span style={{color: "rgb(84, 84, 84)"}}>
                &nbsp;&nbsp;KPR 100% Approved
              </span>
            </div>
          </div>
        </div>
        <div className="button">
          <div className="container-wa">
            <button
              className="buttonpenawaran"
              onClick={handleConsultationClick}>
              Learn More
            </button>
          </div>
        </div>
      </div>
      <div className="gambarabout">
        <img src={aboutimg} alt={aboutimg} />
      </div>
    </div>
  );
};

export default About;
